/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ConfigurationManagementOptionsResponse {
    getFixupPrototypeFunction() { return ConfigurationManagementOptionsResponse.fixupPrototype; }

    static newInstance(model: Partial<ConfigurationManagementOptionsResponse>): ConfigurationManagementOptionsResponse {
        let obj = Object.assign(new ConfigurationManagementOptionsResponse(), model);
        ConfigurationManagementOptionsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ConfigurationManagementOptionsResponse>): ConfigurationManagementOptionsResponse {
        if (!model) return null;
        return ConfigurationManagementOptionsResponse.newInstance(<ConfigurationManagementOptionsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ConfigurationManagementOptionsResponse) {
        if (!obj) return;

        models.ConfigurationManagementOptionsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ConfigurationManagementOptionsResponse): boolean {
        Object.setPrototypeOf(obj, ConfigurationManagementOptionsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.inventory) {
            for (let val of this.inventory) {
                models.ConfigurationManagementOption.fixupPrototype(val);
            }
        }
        if (this.policy) {
            for (let val of this.policy) {
                models.ConfigurationManagementOption.fixupPrototype(val);
            }
        }
    }

    /**
     * Inventory configuration management options
     */
    inventory: Array<models.ConfigurationManagementOption>;

    /**
     * Policy configuration management options
     */
    policy: Array<models.ConfigurationManagementOption>;

}
